import * as config from '../assets/app-config.json';
export const environment = {
    production: false,
    name: 'Dev',
    configUrl:config,
    imgBasURL:"assets/ooki-assets/",
    baseUrl: "https://api.dev.ooki.io",
    appBaseUrl: "https://app.dev.ooki.io",
    baseUrlProd:"https://api.dev.ooki.io/public-auth/Crowdfunding",
    cmsBaseUrl:"https://cms.ooki.io",
    apiUrl: 'https://api.dev.ooki.io',
    secretKey: '8D5A11EB-139D-4F48-A710-32E9D5114ABF',
    partnerId: '2C943A4B-45CE-4A66-B98D-3A61F8F8AD80',
    TooltipDerogatory: 'Derogatory marks are negative items such as missed payments, bankruptcy, county court judgements and debt relief orders.',
    TooltipLoansGuaranteedRate: 'This means the lender cannot change the rate advertised as you progress the application.',
    TooltipLoansVariableRate: 'This means a lender may change the rate to a higher APR as you progress through the application.',
    TooltipForPreApproved100: 'Your chances of receiving this loan are extremely high, however this is subject to further lender checks.'
  };
  